import request from '@/utils/request'
import axios from 'axios'
import { getToken } from '@/utils/auth'
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: true,
  timeout: 30000
})
// 收款单新增
export function addReceipt(data) {
    return request({
      url: '/receipt',
      method: 'post',
      data
    })
  }
  // 收款单详情
  export function getReceipt(id) {
    return request({
      url: `/receipt/${id}`,
      method: 'get',
    })
  }
  // 收款单修改
  export function updateReceipt(data) {
    return request({
      url: '/receipt',
      method: 'put',
      data
    })
  }
  // 收款单删除
export function delReceipt(id) {
    return request({
      url: `/receipt/${id}`,
      method: 'delete'
    })
  }
  // 开票单新增
export function addInvoice(data) {
  return request({
    url: '/invoicing',
    method: 'post',
    data
  })
}
// 开票单详情
export function getInvoice(id) {
  return request({
    url: `/invoicing/${id}`,
    method: 'get',
  })
}
// 开票单修改
export function updateInvoice(data) {
  return request({
    url: '/invoicing',
    method: 'put',
    data
  })
}
// 开票单删除
export function delInvoice(id) {
  return request({
    url: `/invoicing/${id}`,
    method: 'delete'
  })
}
// 开票单审核
export function aduitInvoice(data) {
  return request({
    url: `/invoicing/audit`,
    method: 'post',
    data
  })
}
// 应收单详情
export function getReceivable(id) {
  return request({
    url: `/receivable/${id}`,
    method: 'get',
  })
}
// 收款单获取项目
export function getProject(params) {
  return request({
    url: `/projectDelivery/selectProject`,
    method: 'get',
    params
  })
}
export function exportStatisticsExcel(that,p) {
  service({
    method: 'post',
    url: '/receipt/exportReceiptStatisticsExcel',
    params: p,
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    responseType: 'blob'
  }).then(response => {
      const fileName = `项目收款统计报表.xlsx`
      const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' })
      const downloadElement = document.createElement('a')
      const href = window.URL.createObjectURL(blob)
      downloadElement.href = href
      downloadElement.download = fileName
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
      that.downloadLoading.close();
      that.loading = false;
  }).catch(error => {
      console.log(error)
  })
}
// 获取角色
export function getRole() {
  return request({
    url: `/receipt/getRole`,
    method: 'get'
  })
}
